module.exports = __webpack_public_path__ + "img/碳足迹管理-版本2@1x.3385cdd1.png";